import { isString } from 'lodash-es'

// Reserved host (RFC 6761) used only to detect off-origin redirects; never
// navigated to. A fixed base keeps the check SSR-safe (no window dependency).
const SAME_ORIGIN_SENTINEL = 'https://settle.invalid'

export const isNextUrlValid = (next: Maybe<string>): next is string => {
  if (!isString(next) || !next.startsWith('/') || next.startsWith('//')) {
    return false
  }

  try {
    return new URL(next, SAME_ORIGIN_SENTINEL).origin === SAME_ORIGIN_SENTINEL
  } catch {
    return false
  }
}
